import { SideNavCategory } from '../../../components/side-nav';
import { ReportField } from '../../../models/reportField';

const filterReportFields = (
  categories: Array<SideNavCategory<ReportField>>,
  ignoreReportFieldIds: Set<string>,
): Array<SideNavCategory<ReportField>> => {
  const doFilter = (
    cats: Array<SideNavCategory<ReportField>>,
  ): Array<SideNavCategory<ReportField>> => {
    const filteredFields = cats?.reduce((acc, cat) => {
      const nextCat = { ...cat };
      if (!nextCat.items && ignoreReportFieldIds.has(nextCat.key)) {
        return acc;
      }
      if (nextCat.items) {
        nextCat.items = doFilter(
          nextCat.items as Array<SideNavCategory<ReportField>>,
        );
      }
      acc.push(nextCat);
      return acc;
    }, []);
    return filteredFields;
  };
  return doFilter(categories);
};

export default filterReportFields;
